<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/access">アクセス</router-link></li>
          <li><router-link to="/access/brt">BRTをご利用の方</router-link></li>
        </ul>
      </div>
    </div>
    <div class="access">
      <div class="container">
        <h2 class="page--title">ACCESS<span>アクセス</span></h2>
        <AccessMenu :accessMenuChild="accessMenu" />
        <div class="tab-content">
          <div id="content--2" class="access__content content--2">
            <div class="access__content__title">
              <h2>東京BRT※のルート</h2>
              <a href="">※<span>BRTとは</span></a>
            </div>
            <div class="access__content__route">
              <div class="access__content__route__map">
                <img
                  src="@/assets/img/access/access_img_4.jpg"
                  alt="access map"
                />
              </div>
              <div class="access__content__route__address">
                <dl>
                  <dt>選手村ルート</dt>
                  <dd>新橋・勝どき・晴海五丁目（選手村）</dd>
                  <dt>幹線ルート</dt>
                  <dd>
                    虎ノ門・新橋駅・勝どき・晴海五丁目・市場前駅・有明テニスの森・国際展示場駅・東京
                  </dd>
                  <dt>晴海・豊洲ルート</dt>
                  <dd>
                    虎ノ門・新橋駅・勝どき・晴海三丁目・晴海二丁目・豊洲駅・市場前駅
                  </dd>
                  <dt>勝どきルート</dt>
                  <dd>新橋駅・勝どき</dd>
                </dl>
              </div>
            </div>
            <h2>HARUMI FLAG敷地内のバス停留所</h2>
            <div class="img_holder">
              <img
                src="@/assets/img/access/access_img_1.jpg"
                alt="access map"
              />
            </div>
            <h2>HARUMI FLAG 敷地内発の各ルート所要時間</h2>
            <div class="access__content__imglist">
              <div class="access__content__imglist__item">
                <img
                  src="@/assets/img/access/access_table_1.jpg"
                  alt="access map"
                />
              </div>
              <div class="access__content__imglist__item">
                <img
                  src="@/assets/img/access/access_table_2.jpg"
                  alt="access map"
                />
              </div>
              <div class="access__content__imglist__item">
                <img
                  src="@/assets/img/access/access_table_3.jpg"
                  alt="access map"
                />
              </div>
            </div>
            <div class="link_holder">
              <a href="">
                <img
                  class="icocalender"
                  src="@/assets/img/access/svgfile/icon_cal_clock.svg"
                  alt=""
                />
                <span>HARUMI FLAG 敷地内発のバス時刻表</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
            <h2>BRTとは</h2>
            <p>
              説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。説明が入ります。
            </p>
            <div class="img_holder">
              <img
                src="@/assets/img/access/access_img_5.jpg"
                alt="access map"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import CONSTANT from "../../../constant";
import { RouterLink } from "vue-router";

export default {
  name: "Brt",
  components: {
    AccessMenu: () => import("@/components/common/AccessMenu.vue"),
  },
  data() {
    return {
      accessMenu: CONSTANT.dataAccessMenu,
    };
  },

  computed: {},
};
</script>